'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/date-picker/style/css');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var Search = _input2.default.Search;
var RangePicker = _datePicker2.default.RangePicker;


var FinanceFilter = _react2.default.createClass({
  displayName: 'FinanceFilter',

  propTypes: {
    filter: _react.PropTypes.object.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },
  onStateChange: function onStateChange(e) {
    this.props.onChange('type', e.target.value);
  },
  onDateChange: function onDateChange(date, dateString) {
    if (dateString[0] && dateString[0] !== '') {
      dateString[0] = Date.parse(dateString[0] + ' 00:00:00');
      dateString[1] = Date.parse(dateString[1] + ' 23:59:59');
    }
    this.props.onChange('date', dateString);
  },
  onKeywordChange: function onKeywordChange(keyword) {
    this.props.onChange('keyword', keyword);
  },
  render: function render() {
    var _props$filter = this.props.filter,
        type = _props$filter.type,
        date = _props$filter.date,
        keyword = _props$filter.keyword;

    return _react2.default.createElement(
      'div',
      { className: 'filter' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u4EA4\u6613\u7C7B\u578B\uFF1A'
        ),
        _react2.default.createElement(
          RadioGroup,
          { onChange: this.onStateChange, value: type },
          _react2.default.createElement(
            RadioButton,
            { value: '' },
            '\u5168\u90E8'
          ),
          _react2.default.createElement(
            RadioButton,
            { key: '1', value: '1' },
            '\u652F\u4ED8'
          ),
          _react2.default.createElement(
            RadioButton,
            { key: '2', value: '2' },
            '\u9000\u6B3E'
          ),
          _react2.default.createElement(
            RadioButton,
            { key: '3', value: '3' },
            '\u8FD4\u4F63'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u4EA4\u6613\u65F6\u95F4\uFF1A'
        ),
        _react2.default.createElement(RangePicker, { onChange: this.onDateChange,
          defaultValue: date.length > 0 ? [(0, _moment2.default)(date[0]), (0, _moment2.default)(date[1])] : null })
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u5173\u952E\u8BCD\uFF1A\xA0\xA0\xA0\xA0'
        ),
        _react2.default.createElement(Search, { defaultValue: keyword,
          placeholder: '\u5185\u90E8\u6D41\u6C34\u53F7/\u8BA2\u5355\u53F7\uFF0C\u6309\u56DE\u8F66\u952E\u641C\u7D22',
          onSearch: this.onKeywordChange
        })
      )
    );
  }
});

exports.default = FinanceFilter;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/finance_filter.js
// module id = 1320
// module chunks = 0